#@import Booking.Views.Collection
#@export Booking.Views.PickerCollection

class Booking.Views.PickerCollection extends Booking.Views.Collection

  constructor: ->
    Booking.Views.Collection.apply this, arguments
    @on 'picker:element:select', @select, this

  select: (selection) ->
    @trigger 'picker:select', selection
